import { useContext } from 'react';
import { ApiContext } from '../services/api';

const useApi = () => useContext(ApiContext);

export default useApi; 
